import { withRouter } from 'react-router-dom';
import Button from './Button';

export default withRouter(Button);
